export const MONITORING_STATISTICS = "MONITORING_STATISTICS";
export const MONITORING_ORDERS_EXTENDED = "MONITORING_ORDERS_EXTENDED";
export const MONITORING_CAPTAINS_EXTENDED = "MONITORING_CAPTAINS_EXTENDED";
export const MONITORING_REPORT = "MONITORING_REPORT";
export const ASSIGNMENT_METHODS_REPORT = "ASSIGNMENT_METHODS_REPORT";